import sweepQueryKeys from "./query-keys";
import { sweepSettingsCreate } from "./sweep-settings/create";
import { sweepSettingsEntity } from "./sweep-settings/entity";

export const sweepQueries = {
  settings: {
    entity: sweepSettingsEntity,
    create: sweepSettingsCreate,
  },
};

export { sweepQueryKeys };
